import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { PrimaryBtn, GhostBtn } from "@/components/admin/ui";
import { Check, X, Clock, User } from "lucide-react";

export default function ApprovalsPanel() {
  const [pending, setPending] = useState([]);

  const load = () => api.get("/admin/championships/pending").then((r) => setPending(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const approve = async (id) => {
    await api.post(`/championships/${id}/approve`);
    toast.success("Campionato approvato e pubblicato");
    load();
  };
  const reject = async (id) => {
    const note = window.prompt("Motivo del rifiuto (opzionale):") || "";
    await api.post(`/championships/${id}/reject`, { note });
    toast("Campionato rifiutato");
    load();
  };

  return (
    <div>
      <h2 className="font-heading text-xl font-bold uppercase text-zinc-100 mb-2">Approvazioni</h2>
      <p className="text-sm text-zinc-500 mb-6">Campionati e modifiche in attesa del tuo consenso.</p>

      {pending.length === 0 ? (
        <p className="text-zinc-500 py-10 text-center" data-testid="empty-approvals">Nessuna richiesta in attesa.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {pending.map((c) => (
            <div key={c.id} data-testid={`approval-${c.id}`} className="border border-yellow-400/30 bg-zinc-900 p-5">
              <span className="inline-flex items-center gap-1.5 text-[10px] font-bold tracking-[0.15em] uppercase text-yellow-400 mb-2">
                <Clock className="h-3 w-3" /> In attesa
              </span>
              <h3 className="font-heading text-lg font-bold text-zinc-50">{c.name}</h3>
              <p className="text-xs text-zinc-500 mt-1">{c.category === "rc" ? "RC" : `SIM · ${c.platform || "—"}`}</p>
              <p className="text-sm text-zinc-400 mt-2 line-clamp-2">{c.description || "—"}</p>
              <div className="flex items-center gap-1.5 text-xs text-zinc-500 mt-3">
                <User className="h-3.5 w-3.5" /> {c.owner_name} · {c.owner_email}
              </div>
              <div className="mt-4 flex gap-2">
                <PrimaryBtn onClick={() => approve(c.id)} data-testid={`approve-${c.id}`} className="flex-1">
                  <Check className="h-4 w-4" /> Approva
                </PrimaryBtn>
                <GhostBtn onClick={() => reject(c.id)} data-testid={`reject-${c.id}`}>
                  <X className="h-4 w-4" /> Rifiuta
                </GhostBtn>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
